const algoliasearch = require('algoliasearch/lite')
import instantsearch from 'instantsearch.js'
import { connectHits } from 'instantsearch.js/es/connectors'
import { searchBox } from 'instantsearch.js/es/widgets'

/*
 To keep this flexible, we're making both filtering
 widgets optional. They'll only render if their attributes
 have a DOM element
 */

import {
  configure,
  categories,
  products,
  types,
  refinements,
  paginationWidget,
} from '../../widgets/algolia/documentLibrary'
import { documentLibraryConfig } from '../../config/algolia'

const widgets = [configure, categories, products, types, refinements, paginationWidget]

export default ($el) =>
  ({
    results: null,
    groupedResults: false,
    noResults: true,
    isLoaded: false,
    transform: '',
    groupBy(list, keyGetter) {
      const map = new Map()

      list.forEach((item) => {
        const key = keyGetter(item)
        const collection = map.get(key)

        if (!collection) {
          map.set(key, [item])
        } else {
          collection.push(item)
        }
      })
      return map
    },
    el: $el,
    init() {
      const { index, appId, apiKey } = documentLibraryConfig
      // const searchPlaceholder = 'Search.'
      const searchPlaceholder = this.el.querySelector('[data-widget="library-search"]').dataset
        .placeholder ?? 'Search...'

      // Start Algolia Client
      const algoliaClient = algoliasearch(appId, apiKey)
      // Build Search
      const search = instantsearch({
        indexName: index,
        searchClient: algoliaClient,
        searchFunction(helper) {
          helper.search()
        },
      })

      const structuredResults = connectHits(({ hits }) => {
        if (typeof (hits) !== 'undefined' && hits.length) {
          this.noResults = false
          this.results = hits
          this.groupedResults = Array.from(this.groupBy(this.results, (item) =>
            item.Type))
        } else {
          this.noResults = true
          this.groupedResults = false
          this.results = []
        }
      })

      /*
         * Add our widgets that are imported
         * from js/widgets/algolia/products/index.js
         */

      search.addWidgets([
        searchBox({
          container: '[data-widget="library-search"]',
          placeholder: searchPlaceholder,
          showReset: false,
          showSubmit: false,
          cssClasses: {
            root: ['form__algolia-search--simple'],
            input: ['form__algolia-search--simple-input'],
            form: ['form__algolia-search--simple-form'],
            submit: ['form__algolia-search--simple-submit'],
            reset: ['form__algolia-search--simple-reset'],
          },
        }),
        ...widgets,
        structuredResults(),
      ])

      // Start Search
      search.start()

      // search callbacks
      // @link: https://www.algolia.com/doc/api-reference/widgets/instantsearch/js/#events
      // @link: https://community.algolia.com/instantsearch.js/v1/documentation/#events
      search.on('render', () => {
        this.isLoaded = true
      })
    },
  })
